import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgSustainabilityErrorBox',
})
export default class CmgSustainabilityErrorBox extends Vue {
  @Prop({ required: true, type: Function })
  onRefresh!: () => void;

  get refreshIcon(): string {
    return this.$appStore.state.cms.images.icons.refresh.default;
  }
}
